import type { UserAccessSnapshot } from '@/features/commandDeck/contracts/types'

/** Fail-closed anonymous / error snapshot — no elevated tools. */
export const VISITOR_ACCESS_SNAPSHOT: UserAccessSnapshot = {
  accessState: 'visitor',
  accountReadiness: 'not_ready',
  serviceAccessMode: 'controlled',
}
